<template>
  <mdbContainer fluid>
    <FindMemberPhonenumbers v-on:customer-loaded="customerLoaded" />
    <mdbRow v-if="customerId !== null">
      <mdbCol col="12">
        <ag-grid-vue :style="'width:' + width + ';' + 'height:' + height + ';'" class="ag-theme-alpine"
          :pagination="true" :columnDefs="customers.columns" :rowData="customers.rows" @grid-ready="onGridReady"
          :rowHeight="100" />
      </mdbCol>
    </mdbRow>
    <mdbRow v-if="customerId !== null">
      <mdbCol>
        <ChangeMemberPhonenumber :customerId="customerId" :oldPhoneNumber="oldPhoneNumber"
          v-on:customer-phonenumber-changed="phoneNumberChanged" />
      </mdbCol>
    </mdbRow>
  </mdbContainer>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import FindMemberPhonenumbers from "../components/FindMemberPhonenumbers.vue";
import ChangeMemberPhonenumber from "../components/ChangeMemberPhonenumber.vue";
import SimpleButtonGroup from "../components/SimpleButtonGroup.vue";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "ManageMemberPhoneNumbers",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    FindMemberPhonenumbers,
    ChangeMemberPhonenumber,
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    SimpleButtonGroup,
  },
  data() {
    return {
      deletecustomerpath: "/1.0/front/customer/delete",
      oldPhoneNumber: "",
      dataLoadReady: false,
      gridApi: null,
      gridColumnApi: null,
      customerId: null,
      width: "1350px",
      height: "500px",
      customers: {
        columns: [
          {
            headerName: "Toiminto",
            field: "action",
            pinned: "left",
            resizable: true,
            cellRenderer: "SimpleButtonGroup",
            cellRendererParams: {
              buttons: ["Poista"],
              clicked: function (id, button) {
                this.deleteConfirmed(id);
                console.log("Button " + button + " clicked for id " + id);
              }.bind(this),
            },
          },
          {
            field: "id",
            headerName: "Id",
            width: 250,
            resizable: true,
          },
          {
            headerName: "Puhelinnumero",
            field: "tel",
            width: 200,
            resizable: true,
          },
          {
            headerName: "Nimi",
            field: "name",
            width: 200,
            resizable: true,
          },
          {
            headerName: "Surrogaatti",
            field: "surrogate",
            width: 200,
            resizable: true,
          },
          {
            headerName: "Sähköposti",
            field: "email",
            width: 250,
            resizable: true,
          },
          {
            headerName: "Luotu",
            field: "created",
            width: 250,
            resizable: true,
          },
        ],
        rows: null,
      },
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    phoneNumberChanged(val) {
      console.log(val);
    },
    customerLoaded(customers) {
      this.customers.rows = customers;
      this.customerId = customers[0].id;
      this.oldPhoneNumber = customers[0].tel;
    },
    deleteConfirmed(id) {
      if (confirm("Haluatko varmasti poistaa tämän puhelinnumeron?")) {
        this.postdata = JSON.stringify({
          customerid: id,
      });
      this.$http
        .post(this.deletecustomerpath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("archive_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
            this.$router.go();
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("archive_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
      }
    },
  },
};
</script>